import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const dispatchAdviceByPlanningListTodo = createAsyncThunk('dispatchAdviceByPlanningList', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `dispatch-advice-by-planning`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'deliveryDate': data?.deliveryDate && moment(data?.deliveryDate).format('YYYY-MM-DD'),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const dispatchAdviceByPlanningListSlice = createSlice({
    name: 'dispatchAdviceByPlanningList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(dispatchAdviceByPlanningListTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(dispatchAdviceByPlanningListTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default dispatchAdviceByPlanningListSlice.reducer; 